import { z } from 'zod';

/**
 * path: ルーティングのパス
 * category: Backendが要求するカテゴリ
 */
export const SoftwareAlertType = {
  noWorker: {
    key: 'noWorker',
    path: 'no-worker',
    category: 'NO_WORKER'
  },
  violatedAssignment: {
    key: 'violatedAssignment',
    path: 'violated-assignment',
    category: 'VIOLATED'
  },
  violatedRole: {
    key: 'violatedRole',
    path: 'violated-role',
    category: 'VIOLATED_ROLE'
  },
  noUser: {
    key: 'noUser',
    path: 'no-user',
    category: 'NO_USER'
  },
  inactive: {
    key: 'inactive',
    path: 'inactive-user',
    category: 'INACTIVE'
  },
  alumni: {
    key: 'alumni',
    path: 'alumni',
    category: 'ALUMNI'
  }
} as const;
export type SoftwareAlertCategory = (typeof SoftwareAlertType)[keyof typeof SoftwareAlertType]['category'];
export type SoftwareAlertType = keyof typeof SoftwareAlertType;

/**
 * アカウントステータス（ルール評価以前）の区分: 不明 / 休眠 / 離籍者。
 * 左サイドバーの「アカウントステータス」グループに並べる。
 * ルール由来の区分（アカウントロール）は同じサイドバーの別グループで扱う。
 */
export const ACCOUNT_STATE_ALERT_KEYS: SoftwareAlertType[] = [SoftwareAlertType.noWorker.key, SoftwareAlertType.inactive.key, SoftwareAlertType.alumni.key];
export const SearchSchema = z.object({
  page: z.number().optional(),
  pageSize: z.number().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional()
});